(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/components/categories/categories.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/components/categories/categories.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect,
  useMemo = _React.useMemo,
  useRef = _React.useRef,
  useState = _React.useState;
const Icon = svs.ui.ReactIcon;
const CategoryCard = svs.tickets.next.components.categories.CategoryCard;
const DESKTOP_PAGE_SIZE = 4;
const DESKTOP_MIN_WIDTH = 768; 

const useIsDesktop = () => {
  const _useState = useState(() => {
      if (typeof window === 'undefined' || !window.matchMedia) {
        return false;
      }
      return window.matchMedia("(min-width: ".concat(DESKTOP_MIN_WIDTH, "px)")).matches;
    }),
    _useState2 = _slicedToArray(_useState, 2),
    isDesktop = _useState2[0],
    setIsDesktop = _useState2[1];
  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) {
      return undefined;
    }
    const mql = window.matchMedia("(min-width: ".concat(DESKTOP_MIN_WIDTH, "px)"));
    const onChange = event => setIsDesktop(event.matches);
    if (mql.addEventListener) {
      mql.addEventListener('change', onChange);
    } else if (mql.addListener) {
      mql.addListener(onChange);
    }
    return () => {
      if (mql.removeEventListener) {
        mql.removeEventListener('change', onChange);
      } else if (mql.removeListener) {
        mql.removeListener(onChange);
      }
    };
  }, []);
  return isDesktop;
};
const CategorySection = _ref => {
  let category = _ref.category;
  const isDesktop = useIsDesktop();
  const items = useMemo(() => (category.items || []).filter(item => item && item.active !== false), [category.items]);
  const _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    page = _useState4[0],
    setPage = _useState4[1];
  const trackRef = useRef(null);
  const pageCount = isDesktop ? Math.max(1, Math.ceil(items.length / DESKTOP_PAGE_SIZE)) : 1;
  const safePage = Math.min(page, pageCount - 1);
  useEffect(() => {
    if (page > pageCount - 1) {
      setPage(pageCount - 1);
    }
  }, [page, pageCount]);
  const handlePrev = useCallback(() => {
    setPage(current => Math.max(0, current - 1));
  }, []);
  const handleNext = useCallback(() => {
    setPage(current => Math.min(pageCount - 1, current + 1));
  }, [pageCount]);
  if (items.length === 0) {
    return null;
  }
  const sectionTitleId = "tickets-category-".concat((category.categoryName || 'kategori').replace(/\s+/g, '-').toLowerCase());
  return React.createElement("section", {
    "aria-labelledby": sectionTitleId,
    className: "tickets-category-section ".concat(isDesktop ? 'tickets-category-section--desktop' : 'tickets-category-section--mobile')
  }, React.createElement("div", {
    className: "tickets-category-section__header"
  }, React.createElement("h2", {
    className: "tickets-category-section__title",
    id: sectionTitleId
  }, category.categoryName), isDesktop && pageCount > 1 && React.createElement("div", {
    "aria-label": "Bl\xE4ddra bland erbjudanden",
    className: "tickets-category-section__pagination",
    role: "group"
  }, React.createElement("button", {
    "aria-label": "Visa f\xF6reg\xE5ende",
    className: "tickets-category-section__arrow qa-tickets-category-prev",
    disabled: safePage === 0,
    onClick: handlePrev,
    type: "button"
  }, React.createElement(Icon, {
    icon: "menu-left",
    size: "200"
  })), React.createElement("ol", {
    "aria-hidden": "true",
    className: "tickets-category-section__dots"
  }, Array.from({
    length: pageCount
  }).map((_, index) => React.createElement("li", {
    className: "tickets-category-section__dot ".concat(index === safePage ? 'tickets-category-section__dot--active' : ''),
    key: index
  }))), React.createElement("button", {
    "aria-label": "Visa n\xE4sta",
    className: "tickets-category-section__arrow qa-tickets-category-next",
    disabled: safePage === pageCount - 1,
    onClick: handleNext,
    type: "button"
  }, React.createElement(Icon, {
    icon: "menu-right",
    size: "200"
  })))), isDesktop ? React.createElement("div", {
    className: "tickets-category-section__viewport"
  }, React.createElement("div", {
    className: "tickets-category-section__track",
    ref: trackRef,
    style: {
      transform: "translate3d(-".concat(safePage * 100, "%, 0, 0)")
    }
  }, Array.from({
    length: pageCount
  }).map((_, pageIndex) => {
    const pageItems = items.slice(pageIndex * DESKTOP_PAGE_SIZE, (pageIndex + 1) * DESKTOP_PAGE_SIZE);
    return React.createElement("ul", {
      className: "tickets-category-section__page",
      key: pageIndex
    }, pageItems.map((item, itemIndex) => React.createElement("li", {
      className: "tickets-category-section__item",
      key: "".concat(pageIndex, "-").concat(itemIndex)
    }, React.createElement(CategoryCard, {
      item: item
    }))));
  }))) : React.createElement("ul", {
    className: "tickets-category-section__scroller",
    ref: trackRef
  }, items.map((item, itemIndex) => React.createElement("li", {
    className: "tickets-category-section__item",
    key: itemIndex
  }, React.createElement(CategoryCard, {
    item: item
  })))));
};
const Categories = _ref2 => {
  let categories = _ref2.categories;
  const list = useMemo(() => (categories || []).filter(category => category && (category.items || []).some(item => item && item.active !== false)), [categories]);
  if (list.length === 0) {
    return null;
  }
  return React.createElement("div", {
    className: "tickets-categories"
  }, list.map((category, index) => React.createElement(CategorySection, {
    category: category,
    key: "".concat(category.categoryName || 'kategori', "-").concat(index)
  })));
};
setGlobal('svs.tickets.next.components.categories.CategorySection', CategorySection);
setGlobal('svs.tickets.next.components.categories.Categories', Categories);

 })(window);